export default "__VITE_ASSET__57fa3bcd__"